import {Button as MUIButton, ButtonProps as MUIButtonProps} from '@mui/material';
import {Tooltip} from '../tooltip/tooltip';

export interface ButtonProps extends MUIButtonProps {
  //
}

export function Button(props: ButtonProps) {
  return <MUIButton {...props} />;
}

export interface ButtonTooltipProps extends ButtonProps {
  disabledTooltip?: string;
}

/** Adds a tooltip when the button is disabled. */
Button.Tooltip = function ButtonTooltip({disabledTooltip, ...rest}: ButtonTooltipProps) {
  return (
    <Tooltip.NotAllowedIf condition={rest.disabled} title={disabledTooltip}>
      <Button {...rest} />
    </Tooltip.NotAllowedIf>
  );
};
